import { render, staticRenderFns } from "./MbImageSelect.vue?vue&type=template&id=3c25f1a0&scoped=true&"
import script from "./MbImageSelect.vue?vue&type=script&lang=js&"
export * from "./MbImageSelect.vue?vue&type=script&lang=js&"
import style0 from "./MbImageSelect.vue?vue&type=style&index=0&id=3c25f1a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25f1a0",
  null
  
)

export default component.exports